/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createBigNumberClass } from '../../factoriesAny.js';
export var BigNumberDependencies = {
  createBigNumberClass: createBigNumberClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesBigNumberClass.generated.js
// module id = 6
// module chunks = 0